export const ONBOARDING_STATE_FILTER = {
  SENT: 'sent',
  IN_PROGRESS: 'in_progress',
  AWAITING: 'awaiting',
  COMPLETED: 'completed',
  NOT_INITIATED: 'not_initiated',
};

export const ONBOARDING_STATE = {
  [ONBOARDING_STATE_FILTER.SENT]: [0],
  [ONBOARDING_STATE_FILTER.IN_PROGRESS]: [1, 2, 3],
  [ONBOARDING_STATE_FILTER.AWAITING]: [4],
  [ONBOARDING_STATE_FILTER.COMPLETED]: [5],
  [ONBOARDING_STATE_FILTER.NOT_INITIATED]: [1001],
};

export function convertOnboardingStatusFilterToState(filterArray) {
  let state = [];
  filterArray?.forEach(filter => {
    state.push(...ONBOARDING_STATE[filter]);
  });
  return state;
}
